import lmsAPI from "./lmsAPI";

class LanguageSettingsService {
  async index() {
    const res = await lmsAPI.get("/language_settings");
    return res.data;
  }

  async update(localizationParams) {
    const res = await lmsAPI.put(`/language_settings`, {
      localization: localizationParams,
    });
    return res.data;
  }
}

export default new LanguageSettingsService(); 